import { PatternsErrorKeys } from '@foxeet/domain';
import { Pattern } from '../interfaces';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const VALIDATOR_ONLY_DECIMALS: Pattern = {
  pattern: /^\d+$/,
  errorKey: PatternsErrorKeys.PATTERN,
};

export const VALIDATOR_DOUBLE: Pattern = {
  pattern: /^((\d)+([,.]+(\d)+)*)*$/,
  errorKey: PatternsErrorKeys.PATTERN,
};

export const CUSTOM_EMAIL: Pattern = {
  pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  errorKey: PatternsErrorKeys.EMAIL_VALIDATION_ERROR,
};

export const CUSTOM_EMAIL_ALT: Pattern = {
  pattern: /^[A-z0-9._%+-]+@[A-z0-9.-]+\.[A-z]{1,36}$/,
  errorKey: PatternsErrorKeys.EMAIL_VALIDATION_ERROR_ALT,
};

export const BUDGET_NUMBER_MASK: Pattern = {
  pattern: /^(\d{6}-\d{6}|)$/,
  errorKey: PatternsErrorKeys.BUDGET_NUMBER_MASK_ERROR,
};

export const VALIDATOR_IDUFIR: Pattern = {
  pattern: /^[0-9]{0,14}$/,
  errorKey: PatternsErrorKeys.PATTERN,
};

export const VALIDATOR_POSTALCODE: Pattern = {
  pattern: /^\d{5}$/,
  errorKey: PatternsErrorKeys.PATTERN,
};

export const VALIDATOR_PHONE: Pattern = {
  pattern: /^\d{9}$/,
  errorKey: PatternsErrorKeys.PATTERN,
};

export const VALIDATOR_REQUEST_ID: Pattern = {
  pattern: /^[+]?[1-9]\d*$/,
  errorKey: PatternsErrorKeys.PATTERN,
};

export const ALPHANUMERIC: Pattern = {
  pattern: /^[0-9a-zA-Z]+$/,
  errorKey: PatternsErrorKeys.ALPHANUMERIC,
};

export const PASSWORD: Pattern = {
  // pattern: /^(?=.*\d+)(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.*?[=?<>()'"\/&\t]).{8,}$/, // old one not permit ?<>()'"/&\t
  pattern: /^(?=.{8,})(?:(?=.*\d)(?=.*[a-z])(?=.*[A-Z])|(?=.*\d)(?=.*[a-z])(?=.*\W)|(?=.*\d)(?=.*[A-Z])(?=.*\W)|(?=.*[a-z])(?=.*[A-Z])(?=.*\W)).*$/,
  errorKey: PatternsErrorKeys.FORM_VALIDATION_PASSWORD_DOES_NOT_MATCH,
};

export const postalCodeFn = (province: number): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) {
      return null;
    }

    const hasFiveDigits = VALIDATOR_POSTALCODE.pattern.test(value);
    const areDigits = /^[0-9]+$/.test(value);
    const areFiveZeros = value === '00000';

    const postalCodeInvalidFormat = hasFiveDigits && !areFiveZeros;

    const provinceStr = `${province}`.length === 1 ? `0${province}` : `${province}`;
    const preffixPostalCode = control.value.substring(0, 2);
    const isProvincePostalCode = `${provinceStr}` === preffixPostalCode;

    return !isProvincePostalCode || !postalCodeInvalidFormat
      ? {
          [PatternsErrorKeys.POSTAL_CODE_PROVINCE]: !isProvincePostalCode && !areFiveZeros && areDigits,
          [PatternsErrorKeys.POSTAL_CODE_FORMAT]: !postalCodeInvalidFormat,
        }
      : null;
  };
};

export const cadastralReferenceFn = (ineCodProv?: number): ValidatorFn => {
  const min = ineCodProv === 48 ? 14 : 20;
  const max = 20;

  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value ? String(control.value).trim() : '';

    // Requerido
    if (!value) {
      return { required: true };
    }

    // Mínima longitud
    if (value.length < min) {
      return { minlength: { requiredLength: min, actualLength: value.length } };
    }

    // Máxima longitud
    if (value.length > max) {
      return { maxlength: { requiredLength: max, actualLength: value.length } };
    }

    return null; // válido
  };
};
